export default "/static/featured/bay-area-banner.jpg"